import { render, staticRenderFns } from "./GptProfile.vue?vue&type=template&id=654b2ee8&scoped=true"
import script from "./GptProfile.vue?vue&type=script&lang=js"
export * from "./GptProfile.vue?vue&type=script&lang=js"
import style0 from "./GptProfile.vue?vue&type=style&index=0&id=654b2ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654b2ee8",
  null
  
)

export default component.exports